import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../config/tenantConfig';
import { getMenuForTenant } from '../data/menus';
import { getMenuItemTeaser } from '../utils/menuUtils';
import { trackEvent } from '../utils/analytics';
import { useScrollToTop } from '../hooks/useScrollToTop';
import ArrowLeftIcon from './icons/ArrowLeftIcon';

const MenuList = () => {
  const navigate = useNavigate();
  const tenant = useTenant();
  const menu = getMenuForTenant(tenant.id);
  useScrollToTop(tenant.id);

  useEffect(() => {
    if (menu) {
      trackEvent('menu_open', { tenant: tenant.id });
    }
  }, [menu, tenant.id]);

  useEffect(() => {
    if (!menu) {
      navigate('/', { replace: true });
    }
  }, [menu, navigate]);

  if (!menu) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-wine-dark via-[#1e1a2e] to-wine-dark py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center mb-8">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white hover:text-wine-gold transition-colors"
          >
            <ArrowLeftIcon />
            <span className="text-lg">Voltar</span>
          </button>
        </div>

        <div className="text-center mb-12">
          <h1 className="text-white text-3xl md:text-4xl font-serif mb-4">
            O corte define o vinho.
          </h1>
          <p className="text-gray-400 text-lg">
            Toque no prato e descubra a harmonização da casa.
          </p>
        </div>

        {menu.sections.map((section) => (
          <section key={section.id} className="mb-12">
            <h2 className="text-wine-gold text-2xl font-serif mb-6">{section.name}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {section.items.map((item) => (
                <button
                  type="button"
                  key={item.id}
                  onClick={() => {
                    trackEvent('menu_item_click', {
                      tenant: tenant.id,
                      item: item.id,
                    });
                    navigate(`/menu/${item.id}`);
                  }}
                  className="text-left bg-gradient-to-br from-[#2a2535] to-[#1a1625] rounded-2xl overflow-hidden hover:scale-105 hover:shadow-xl hover:shadow-wine-gold/20 transition-all duration-300 border border-transparent hover:border-wine-gold/50"
                >
                  <div className="h-36 bg-[#3a3545] flex items-center justify-center overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                      }}
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-white text-xl font-serif mb-1.5">{item.name}</h3>
                    <p className="text-gray-400 text-sm leading-snug line-clamp-2">
                      {getMenuItemTeaser(item)}
                    </p>
                    <span className="mt-3 inline-block text-wine-gold text-xs uppercase tracking-wide">
                      Ver vinhos
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default MenuList;
